import { useOutletContext } from "react-router";
import { JSX } from "react";

import RFPs from "../../RFPs";
import { RfpsContext } from "../types";

const DraftRfps = (): JSX.Element => {
  const { brokerId } = useOutletContext<RfpsContext>();

  return <RFPs isDraftList isBrokerPartner brokerId={brokerId} />;
};

export { DraftRfps };
